import React from 'react';
import { Download } from 'lucide-react';
import './TableView.css';

function TableView({ data, tableName, headers }) {
  if (!data || data.length === 0) {
    return <p>No data available for the table.</p>;
  }

  // Use provided headers to maintain column order, or extract from data
  const columnHeaders = headers || Object.keys(data[0]);

  const convertToCSV = (csvData) => {
    const headerRow = columnHeaders.join(',');
    const rows = csvData.map(row => {
      return columnHeaders.map(header => {
        const cell = row[header] === null || row[header] === undefined ? '' : String(row[header]);
        const escaped = cell.replace(/"/g, '""');
        return `"${escaped}"`;
      }).join(',');
    });
    return [headerRow, ...rows].join('\n');
  };

  const handleExport = () => {
    const csvData = convertToCSV(data);
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      // Generate a datetime stamp (YYYYMMDD_HHmmss) to avoid overwriting previous downloads
      const now = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      const dateStamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
      const baseName = tableName ? tableName.replace(/[^a-zA-Z0-9_-]/g, '_') : 'table-data';
      link.setAttribute('href', url);
      link.setAttribute('download', `${baseName}_${dateStamp}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <div className="table-view-wrapper">
      <div className="table-header">
        <h3 className="table-name">{tableName || 'Table'}</h3>
        <Download className="download-icon" onClick={handleExport} />
      </div>
      <div className="table-view-container">
        <table className="table-view">
          <thead>
            <tr>
            {columnHeaders.map((header) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              {columnHeaders.map((header) => (
                <td key={header}>{row[header]}</td>
              ))}
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TableView;
